module.exports = __webpack_public_path__ + "img/visa.db196b1f.svg";